/**
 * Reports Tour Configuration
 *
 * Step-by-step tour for the redesigned Reports page.
 */

import { filterExistingSteps } from './tourUtils.js';

export const getReportsTourSteps = (t) =>
  filterExistingSteps([
    {
      selector: '[data-tour="reports-analytics-btn"]',
      content: t('tour.reports.analyticsBtn', {
        ns: 'common',
        defaultValue: 'Click this button to open the comprehensive analytics modal with charts, insights, and advanced filtering.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="reports-filters"]',
      content: t('tour.reports.filters', {
        ns: 'common',
        defaultValue: 'Use these filters to select date range, payment type, and transaction status to customize your report.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="reports-summary"]',
      content: t('tour.reports.summary', {
        ns: 'common',
        defaultValue: 'View key metrics: total volume, transaction count, and top transaction type for the selected period.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="reports-table"]',
      content: t('tour.reports.table', {
        ns: 'common',
        defaultValue: 'Review detailed transactions here. Export to Excel or navigate through pages.',
      }),
      position: 'top',
    },
  ]);
